import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const useLeaveToVendorPortal = (isDirty: boolean) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return useCallback(() => {
    if (isDirty && !window.confirm(t('form-dirty-text'))) {
      return
    }

    navigate('/vendors')
  }, [isDirty, navigate, t])
}
